window.getCityStreet = function()
{
    const postalCode = document.getElementById('postal_code').value;
    const houseNumber = document.getElementById('house_number').value;
    
    if(postalCode != '' && houseNumber != ''){
        fetch(window.location.origin + '/houses/city-street/' + postalCode, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('[name="csrf-token"]')?.content,
            },
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(result) {
            if(result.land){
                document.getElementById("street").value = result.straat;
                document.getElementById("city").value = result.plaats;
            }else{
                document.getElementById("street").value = '';
                document.getElementById("city").value = '';
            }
        })
        .catch(function(error) {
            // console.error('Error:', error);
        });
    }else{
        document.getElementById("street").value = '';
        document.getElementById("city").value = '';
    }
}